import { PageHeader } from '@/components/common/PageHeader';
import { QuickActionsWidget } from '@/features/dashboard/components/QuickActionsWidget';
import { UsersWidget } from '@/features/dashboard/components/UsersWidget';
import { OrganizationsWidget } from '@/features/dashboard/components/OrganizationsWidget';
import { DomainsWidget } from '@/features/dashboard/components/DomainsWidget';
import { MailboxesWidget } from '@/features/dashboard/components/MailboxesWidget';
import { StorageWidget } from '@/features/dashboard/components/StorageWidget';
import { MailQueueWidget } from '@/features/dashboard/components/MailQueueWidget';
import { RecentActivityWidget } from '@/features/dashboard/components/RecentActivityWidget';

/**
 * Overview dashboard. A responsive 12-column grid of independent widgets, each
 * consuming a real endpoint and owning its own loading/error state so the page
 * renders progressively and degrades gracefully.
 */
export function DashboardPage() {
  return (
    <div>
      <PageHeader title="Overview" description="A live snapshot of your mail platform." />

      <div className="space-y-4">
        {/* Quick actions — full width */}
        <QuickActionsWidget />

        {/* KPI row */}
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5">
          <UsersWidget />
          <OrganizationsWidget />
          <DomainsWidget />
          <MailboxesWidget />
          <StorageWidget />
        </div>

        {/* Queue + activity row */}
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <MailQueueWidget />
          <RecentActivityWidget />
        </div>
      </div>
    </div>
  );
}
